import React from 'react';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AirwaybillContainer from './tabs/airwaybills/AirwaybillContainer';
import FlightManifestContainer from './tabs/flightManifest/FlightManifestContainer';
import OtherDocContainer from './tabs/otherDoc/OtherDocContainer';
import FlightManifestIcon from './../../../assets/images/docArchiveTabIcons/flightmanifest.svg';
import { docArchiveTabs, pagelist } from '../../../custom/constants';
import { IconTab } from '../../../custom/components';
import ConfirmModalContainer from '../common/confirmModal/ConfirmModalContainer';
import adminStyles from '../admin/tabs/admin.module.css';
import docStyles from './tabs/archive.module.css';
import { IconButton } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import theme from 'custom/theme';
import ServiceLogContainer from './tabs/serviceLog/ServiceLogContainer';
import cookies from 'utils/cookies';
let filteredpagelist = pagelist.filter((page) => page?.roles.includes(cookies.get('role')));

const DocArchive = (props) => {
  const { value } = props;
  function TabPanel(tabPanelProps) {
    const { children, index, ...other } = tabPanelProps;
    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {tabPanelProps.value === index && (
          <Box sx={{ pt: 0 }}>
            <Typography component='span'>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(path) {
    const index = path.replace('doc_archive/', '');
    return {
      id: `simple-tab-${index}`,
      value: index,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box>
          <Tabs value={value} onChange={(_, v) => props.handleChange(v)}
            indicatorColor='red'
            textColor='primary'
            variant='scrollable'
            scrollButtons='auto'
            aria-label='scrollable doc archieve tabs'
            classes={{ flexContainer: adminStyles.fJcAround }}
            ScrollButtonComponent={(props) => {
              if (
                props.direction === 'left'
              ) {
                return (
                  <IconButton {...props} className={adminStyles.tabArrows} disableRipple>
                    <ArrowLeftIcon
                      sx={{ color: props.disabled ? 'disabled' : theme.palette.primary.main }}
                    />
                  </IconButton>
                );
              } else if (
                props.direction === 'right'
              ) {
                return (
                  <IconButton {...props} className={adminStyles.tabArrows} disableRipple>
                    <ArrowRightIcon
                      sx={{ color: props.disabled ? 'disabled' : theme.palette.primary.main }}
                    />
                  </IconButton>
                );
              } else {
                return null;
              }
            }}
            className={`${adminStyles.headerTab} ${docStyles.docArchiveTabs}`}>
            {
              filteredpagelist.find((page) => page.title === 'Doc Archive | Airwaybills' ) &&
                <IconTab disableRipple icon={<div className={docStyles.tabheadName}>AWB</div>} label={docArchiveTabs.awbs} {...a11yProps('doc_archive/airwaybills')} />
            }
            {
              filteredpagelist.find((page) => page.title === 'Doc Archive | Flight Manifest' ) &&
                <IconTab disableRipple icon={<img src={FlightManifestIcon} alt='flight_manifest' />} label={docArchiveTabs.flight_manifest} {...a11yProps('doc_archive/flight_manifest')} />
            }
            {
              filteredpagelist.find((page) => page.title === 'Doc Archive | Other Documents' ) &&
                <IconTab disableRipple icon={<div className={docStyles.tabheadName}>OTH</div>} label={docArchiveTabs.other_docs} {...a11yProps('doc_archive/other_documents')} />
            }
            {
              filteredpagelist.find((page) => page.title === 'Doc Archive | Service Logs' ) &&
                <IconTab disableRipple icon={<div className={docStyles.tabheadName}>LOG</div>} label={docArchiveTabs.service_logs} {...a11yProps('doc_archive/service_logs')} />
            }
          </Tabs>
        </Box>

        <TabPanel value={value} index={'airwaybills'}>
          <AirwaybillContainer />
        </TabPanel>

        <TabPanel value={value} index={'flight_manifest'}>
          <FlightManifestContainer />
        </TabPanel>

        <TabPanel value={value} index={'other_documents'}>
          <OtherDocContainer />
        </TabPanel>
        <TabPanel value={value} index={'service_logs'}>
          <ServiceLogContainer />
        </TabPanel>
      </Box>
      <ConfirmModalContainer />
    </>
  );
};

export default DocArchive;
